import { render, staticRenderFns } from "./TeamPerformance.vue?vue&type=template&id=98a994ac&scoped=true"
import script from "./TeamPerformance.vue?vue&type=script&lang=js"
export * from "./TeamPerformance.vue?vue&type=script&lang=js"
import style0 from "./TeamPerformance.vue?vue&type=style&index=0&id=98a994ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a994ac",
  null
  
)

export default component.exports